module.exports = __webpack_public_path__ + "images/pages/for_business/sp/sec06_5c58febace2b5b6cb458d212f5d79434.jpg";